// Copyright 2019 The Oppia Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS-IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * @fileoverview Rules service for the interaction.
 */
var oppia = require('AppInit.ts').module;
oppia.factory('LogicProofRulesService', [function () {
        return {
            Correct: function (answer) {
                return answer.correct;
            },
            NotCorrect: function (answer) {
                return !answer.correct;
            },
            NotCorrectByCategory: function (answer, inputs) {
                return !answer.correct && answer.error_category === inputs.c;
            }
        };
    }]);
